import React from "react";
import { Row, Col, Button } from "reactstrap";
import { T } from "../../traks";
import store from "../../store";

export const PremiumPlanDetails = ({ plan, onClick }) => {
  if (!plan) return null;

  const handleUpgrade = (selectedPlan) => {
    localStorage.setItem("upgrade_months", selectedPlan.months);
    store.dispatch_value("show_cart", true);
  };

  return (
    <Row className="justify-content-center mt-5">
      <Col sm="6" className="text-center">


      <Row>
            <Col>
                <h2 className="premium-details-price">{plan.monthlyPrice}</h2>
                <span><T>/ per participant / per month</T></span>
            </Col>
      </Row>

      <Row className="mt-4">
            <div className="premium-price-underline" />
      </Row>

      <Row sm={12} className="mt-2">
        <Col>
            <h2>{plan.totalPrice} {plan.discountPrice && (
            <span className="premium-discounted-price">
              {plan.discountPrice}
            </span>
          )}{" "}</h2>
            
        </Col>
      </Row>

      <Row>
        <Col>
            <span><T>per participant for the entire period</T></span>
        </Col>
      </Row>

      <Row className="mt-5">
        <Col>
            <Button onClick={() => handleUpgrade(plan)} className="ml-auto mb-auto ad_new_game_button px-4 py-2"><T>Upgrade my game</T></Button>
        </Col>
      </Row>

      <Row className="mt-5 mb-5">
        <Col>
            <span className="premium-vat-details"><T>All prices are including VAT</T></span>
        </Col>
      </Row>
      </Col>
    </Row>
  );
};


// WEBPACK FOOTER //
// ./src/c/Premium/PremiumPlanDetails.js